import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const BackButton = ({ to = '/panel', label = 'Kariyerim' }) => {
  const navigate = useNavigate();

  return (
    <button
      className="back-button"
      onClick={() => navigate(to)}
    >
      <ArrowLeft size={16} />
      {label}
    </button>
  );
};

export default BackButton;
